import {defineStore} from "pinia";

/**
 * @typedef {{id: string, title: string, type: string, price: string, image: string, category: string, url: string}} WishlistItem
 */

/**
 * @type {Object}
 */
export const useWishlistStore = defineStore('wishlist', {
    state: () => ({
        visible: false,
        items: /** @type {WishlistItem[]} */ ([]),
    }),
    getters: {
        count: state => state.items.length,
    },
    actions: {
        show() {
            this.visible = true;
        },
        hide() {
            this.visible = false;
        },
        toggle() {
            this.visible = !this.visible;
        },

        /**
         * @param item {WishlistItem}
         */
        add({id, title, type, price, image, category, url}) {
            this.items.push({id, title, type, price, image, category, url});
        },
        remove(id) {
            this.items = this.items.filter(i => i.id !== id);
        },
        has(id) {
            return this.items.some(i => i.id === id);
        }
    }
});
